export default __webpack_public_path__ + "static/landing-experience-dark-ebc0a8e930d211315750cb33380e81a19451be073040b2c45f43a235b23a998e.png";